import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var SuperScriptIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5236 4.63634C36.8015 3.91421 35.6492 3.91421 34.9271 4.63634L34.3266 5.23683C33.9176 5.64586 33.2544 5.64586 32.8454 5.23683C32.4364 4.82781 32.4364 4.16465 32.8454 3.75563L33.4459 3.15514C34.9861 1.61495 37.4647 1.61495 39.0049 3.15514C40.545 4.69532 40.545 7.17392 39.0049 8.7141L35.9191 11.7999H39.7306C40.309 11.7999 40.7779 12.2688 40.7779 12.8473C40.7779 13.4257 40.309 13.8946 39.7306 13.8946H33.8094C32.8063 13.8946 32.1131 12.6435 32.9432 11.8134L37.5236 7.2329C38.2458 6.51076 38.2458 5.35848 37.5236 4.63634Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26758 7.76402C8.84603 7.76402 9.31495 8.23295 9.31495 8.81139V17.2881C9.31495 21.3879 12.6445 24.7174 16.7443 24.7174C20.8441 24.7174 24.1736 21.3879 24.1736 17.2881V8.81139C24.1736 8.23295 24.6426 7.76402 25.221 7.76402C25.7995 7.76402 26.2684 8.23295 26.2684 8.81139V17.2881C26.2684 22.5448 22.001 26.8122 16.7443 26.8122C11.4876 26.8122 7.22021 22.5448 7.22021 17.2881V8.81139C7.22021 8.23295 7.68914 7.76402 8.26758 7.76402Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.221 7.76402C25.7995 7.76402 26.2684 8.23295 26.2684 8.81139V36.4759C26.2684 41.7326 22.001 46 16.7443 46C14.1078 46 11.7362 44.9309 10.0127 43.2075C9.60372 42.7985 9.60372 42.1353 10.0127 41.7263C10.4218 41.3172 11.0849 41.3172 11.4939 41.7263C12.8428 43.0751 14.6886 43.9053 16.7443 43.9053C20.8441 43.9053 24.1736 40.5757 24.1736 36.4759V8.81139C24.1736 8.23295 24.6426 7.76402 25.221 7.76402Z"
  }));
});
SuperScriptIcon.displayName = 'SuperScriptIcon';
SuperScriptIcon.defaultProps = {
  'aria-label': 'SuperScript'
};
export default SuperScriptIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/SuperScriptIcon/index.js
// module id = 1952
// module chunks = 12